<template>
  <div class="container mt-4">
    <TopNav>
      <NavItem
        icon="far fa-save"
        :text="$t('GENERAL.BUTTON.SAVE')"
        :pulse="isDirty"
        :loading="inProgress"
        @click="saveEvent()"
      />
    </TopNav>
    <div class="content mt-4">
      <h1 class="mt-4 mb-4">{{ $t('EVENTS.TITLE.ADD_EVENT') }}</h1>
      <ValidationObserver ref="form">
        <EventForm :localEvent="localEvent" />
      </ValidationObserver>
      <div class="my-5"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { ValidationObserver } from 'vee-validate';
import TopNav from '@/web/components/navigation/TopNav';
import NavItem from '@/web/components/navigation/NavItem';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import EventForm from '@/web/components/events/EventForm';
import { EVENT_TYPE_BROADCAST } from '@/core/utils/events';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import HMDialog from '@/web/components/common/HMDialog.vue';

export default {
  name: 'NewEvent',
  mixins: [DirtyMixin],
  components: {
    TopNav,
    NavItem,
    EventForm,
    ValidationObserver,
  },
  data() {
    return {
      inProgress: false,
      localEvent: {
        event_type: EVENT_TYPE_BROADCAST,
        products: [],
        registration_required: false,
        post_event_recording_available: false,
        recording_expiration_days: 3,
        registration_limit: 0,
        registration_closes_minutes_before_start: 0,
        unregistration_closes_minutes_before_start: 0,
        duration_hours: 1,
        duration_minutes: 0,
        days_of_week: {},
        date: moment(new Date()).format('YYYY-MM-DD'),
        start_time: this.getNextHourRoundedTime(),
        agreed_to_www_requirements: false,
        is_repeating_event: false,
        is_free_event: false,
        require_first_name: false,
        require_last_name: false,
        hide_registration_info: false,
        email_notifications_enabled: true,
        sms_notifications_enabled: true,
        is_punchable_event: false,
        cover_photo: undefined,
        attachments: [],
        auto_notify_waitlist: true,
      },
    };
  },
  methods: {
    getNextHourRoundedTime() {
      const now = new Date();
      return `${('0' + now.getHours() + 1).slice(-2)}:00`;
    },
    async saveEvent() {
      if (this.inProgress) {
        return;
      }
      console.log('Saving event:', this.localEvent);
      this.$refs.form.validate();
      if (this.$refs.form.flags.invalid) {
        scrollToFirstFormError();
        return;
      }
      this.inProgress = true;
      try {
        const event = await this.$store.dispatch(
          'event/createEvent',
          this.localEvent
        );
        this.onSave(event);
      } catch (error) {
        console.log(error);
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to create the event',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
    async onSave(event) {
      if (event.is_www_event) {
        this.$modal.show(HMDialog, {
          title: this.$t('EVENTS.TITLE.POST_ON_WELLWELLWELL'),
          htmlContent: this.$t('EVENTS.TEXT.POST_ON_WELLWELLWELL_DESCRIPTION'),
          confirmButton: this.$t('EVENTS.BUTTON.VIEW_YOUR_LISTING'),
          discardButton: this.$t('EVENTS.BUTTON.BACK_TO_CALENDAR'),
          confirm: () => {
            this.clearDirty();
            const url = `${process.env.VUE_APP_WELLWELLWELL_BASE_URL}/events/${event.id}`;
            window.open(url);
            this.$router.replace({ name: 'events-calendar' });
          },
          discard: () => {
            this.clearDirty();
            this.$router.replace({ name: 'events-calendar' });
          },
        });
      } else {
        this.clearDirty();
        this.$router.replace({ name: 'events-calendar' });
      }
    },
  },
  mounted() {
    if (this.$route.query.date) {
      this.localEvent.date = this.$route.query.date;
      if (this.$route.query.date.length > 10) {
        const selectedDate = moment(this.localEvent.date).toDate();
        this.localEvent.start_time = `${('0' + selectedDate.getHours()).slice(
          -2
        )}:${('0' + selectedDate.getMinutes()).slice(-2)}`;
      }
    }
  },
  watch: {
    localEvent: {
      handler: function (localEvent, oldLocalEvent) {
        if (oldLocalEvent) {
          this.setDirty();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
